import { render, staticRenderFns } from "./ImageDownloadModal.vue?vue&type=template&id=5cefda52&scoped=true&lang=pug"
import script from "./ImageDownloadModal.vue?vue&type=script&lang=ts"
export * from "./ImageDownloadModal.vue?vue&type=script&lang=ts"
import style0 from "./ImageDownloadModal.vue?vue&type=style&index=0&id=5cefda52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cefda52",
  null
  
)

export default component.exports